import React, { useState, useRef } from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CardTools } from "agronomist-ui-components";
import { useSelector } from "react-redux";
import "./Section.scss";
import { SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import {
  TOOLS,
  TOOLS_TYPES,
  TOOLS_TYPES_META,
} from "../../views/ToolsPage/constans";
import Section from "./Section";
import { CarouselWrapper } from "./CarouselWrapper";

const ToolsCarousel = ({
  subtitle,
  className,
  allowedCategories,
  background = "light", // "light" | "dark"
  slidesPerView,
  showMoreLink = true,
}) => {
  const { t, i18n } = useTranslation(["tools"]);
  const [activeCategory, setActiveCategory] = useState(null);
  const tokenFromStore = useSelector(state => state.user.token);
  const userIsLogin = tokenFromStore !== "";
  const swiper = useRef(null);

  const articlesCategories = Object.values(TOOLS_TYPES)
    .filter(type => type !== TOOLS_TYPES.REGAGRI)
    .map(type => {
      return {
        id: type,
        name: TOOLS_TYPES_META[type].title[i18n.language],
      };
    });

  const categoriesFilter = (
    <div className="Sections__tags">
      <div
        key="category-all"
        className={`Sections__tag ${
          !!activeCategory === false ? "is-active" : ""
        }`}
        onClick={() => setActiveCategory(null)}
      >
        {t("tools:tools.all_kind")}
      </div>
      {articlesCategories.slice(0, 6).map(({ id, name }) => (
        <div
          key={id}
          className={`Sections__tag ${
            activeCategory === id ? "is-active" : ""
          }`}
          onClick={() => setActiveCategory(id)}
        >
          {name.replace("Narzędzia ", "").replace(" Tool", "")}
        </div>
      ))}
      {articlesCategories && articlesCategories.length > 6 && (
        <div key="category-more" className="Sections__tag">
          ...
        </div>
      )}
    </div>
  );

  const tools = TOOLS.filter(
    el =>
      el.slug !== "agrivi" &&
      (!!activeCategory === false || el.types.includes(activeCategory))
  );

  return (
    <div className={`Sections--${background}`}>
      <Container>
        <Section
          className={`
            ${className || ""}
            ${!!articlesCategories && !!allowedCategories && "has-categories"}
            ${!showMoreLink &&
              !subtitle &&
              !allowedCategories &&
              "no-top-padding"}
          `}
          title={<h2>{t("tools:tools.title")}</h2>}
          subtitle={subtitle}
        >
          <>
            <div
              className={`Sections__categories ${!!articlesCategories &&
                "has-categories"}`}
            >
              {!!articlesCategories && categoriesFilter}

              {
                <Link to="/narzedzia" className="Sections__more">
                  {t("tools:tools.all_tools")}
                </Link>
              }
            </div>
            <CarouselWrapper
              slidesPerViewMed={4}
              slidesPerViewBig={slidesPerView || 4}
              swiperRef={swiper}
            >
              {tools.map(el => {
                return (
                  <SwiperSlide
                    key={`slide-${el.slug}`}
                    style={{ height: "auto" }}
                  >
                    <CardTools
                      slug={el.slug}
                      key={el.slug}
                      id={el.slug}
                      icon={el.icon}
                      title={el.title[i18n.language].split(" - ")[0]}
                      description={el.description[i18n.language]}
                      url={userIsLogin ? el.href.user : el.href.anonymous}
                      categories={el.types}
                    />
                  </SwiperSlide>
                );
              })}
            </CarouselWrapper>
          </>
        </Section>
      </Container>
    </div>
  );
};

export default ToolsCarousel;
